/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_NotesInputs */

const en_agent_authorization_field_notes = /** @type {(inputs: Agent_Authorization_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes for the review team`)
};

const zh_agent_authorization_field_notes = /** @type {(inputs: Agent_Authorization_Field_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给审核团队的备注`)
};

/**
* | output |
* | --- |
* | "Notes for the review team" |
*
* @param {Agent_Authorization_Field_NotesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_notes = /** @type {((inputs?: Agent_Authorization_Field_NotesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_NotesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_notes(inputs)
	return zh_agent_authorization_field_notes(inputs)
});
export { agent_authorization_field_notes as "agent.authorization.field.notes" }